export const environment = {
    Production: false,
    ApiURL: 'https://api.test.legalresources.com/v1'
};
